import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './styles/App.scss';

import { ConfigProvider } from './contexts/ConfigContext';
import NavMenu from './components/NavMenu';
import ScrollToTop from './components/ScrollToTop';

import Homepage from './components/Homepage';
import Events from './components/Events';
import Event from './components/Event';
import Reflections from './components/Reflections';
import Reflection from './components/Reflection';
import Resources from './components/Resources';
import PrayerRequest from './components/PrayerRequest';
import PrayerRequestSubmitted from './components/PrayerRequestSubmitted';
import Login from './components/Login';

import Admin from './components/Admin';
import AdminEvents from './components/AdminEvents';
import AdminReflections from './components/AdminReflections';
import AdminReflectionEditor from './components/AdminReflectionEditor';
import AdminResources from './components/AdminResources';
import AdminGallery from './components/AdminGallery';
import AdminPrayerRequests from './components/AdminPrayerRequests';
import AdminConfig from './components/AdminConfig';
import Prayers from './components/Prayers';
import Prayer from './components/Prayer';
import AdminPrayers from './components/AdminPrayers';
import AdminPrayerEditor from './components/AdminPrayerEditor';
import NotFound from './components/NotFound';

function App() {
  return (
    <Router>
      <ConfigProvider>
        <ScrollToTop />
        <Routes>
          {/* Public routes — show nav */}
          <Route path="/" element={<><NavMenu /><Homepage /></>} />
          <Route path="/events" element={<><NavMenu /><Events /></>} />
          <Route path="/events/:id" element={<><NavMenu /><Event /></>} />
          <Route path="/reflections" element={<><NavMenu /><Reflections /></>} />
          <Route path="/reflections/:id" element={<><NavMenu /><Reflection /></>} />
          <Route path="/resources" element={<><NavMenu /><Resources /></>} />
          <Route path="/prayer-request" element={<><NavMenu /><PrayerRequest /></>} />
          <Route path="/prayer-request/submitted" element={<><NavMenu /><PrayerRequestSubmitted /></>} />
          <Route path="/prayers" element={<><NavMenu /><Prayers /></>} />
          <Route path="/prayers/:id" element={<><NavMenu /><Prayer /></>} />

          {/* Auth */}
          <Route path="/login" element={<><NavMenu /><Login /></>} />

          {/* Admin routes */}
          <Route path="/admin" element={<><NavMenu /><Admin /></>} />
          <Route path="/admin/events" element={<><NavMenu /><AdminEvents /></>} />
          <Route path="/admin/reflections" element={<><NavMenu /><AdminReflections /></>} />
          <Route path="/admin/reflections/new" element={<><NavMenu /><AdminReflectionEditor /></>} />
          <Route path="/admin/reflections/:id/edit" element={<><NavMenu /><AdminReflectionEditor /></>} />
          <Route path="/admin/resources" element={<><NavMenu /><AdminResources /></>} />
          <Route path="/admin/gallery" element={<><NavMenu /><AdminGallery /></>} />
          <Route path="/admin/prayer-requests" element={<><NavMenu /><AdminPrayerRequests /></>} />
          <Route path="/admin/prayers" element={<><NavMenu /><AdminPrayers /></>} />
          <Route path="/admin/prayers/new" element={<><NavMenu /><AdminPrayerEditor /></>} />
          <Route path="/admin/prayers/:id/edit" element={<><NavMenu /><AdminPrayerEditor /></>} />
          <Route path="/admin/config" element={<><NavMenu /><AdminConfig /></>} />

          {/* 404 */}
          <Route path="*" element={<><NavMenu /><NotFound /></>} />
        </Routes>
      </ConfigProvider>
    </Router>
  );
}

export default App;
